import { Link } from 'react-router-dom'

function Services() {
  return (
    <>
        
        <div className="flex justify-center place-items-center">
            <div className='flex flex-col 2xl:flex-row w-3/4 text-white'>
                {/* <a href="javascript:void(Tawk_API.toggle())" className='flex-1'>
                    <div className='bg-red-900 flex flex-1 p-10 justify-center place-items-center whitespace-nowrap'>
                        Chat With Us
                    </div>
                </a> */}
                <div className='flex-1' onClick={()=>document.getElementById('request_modal').showModal()} style={{cursor: 'pointer'}}>
                    <div className='bg-red-900 p-8 flex justify-center place-items-center whitespace-nowrap'>
                        Request Kit
                    </div>
                </div>
                <Link to='/locateus' className='flex-1'>
                    <div className='bg-red-700 p-8 flex justify-center place-items-center whitespace-nowrap'>
                        Locate Us
                    </div>
                </Link>
                {/* <Link to='/assessment' className='flex-1'>
                    <div className='bg-red-900 p-8 flex justify-center place-items-center whitespace-nowrap'>
                        HIV Self Assessment
                    </div>
                </Link> */}
            </div>
        </div>
    </>

  )
}

export default Services
